// extracted by mini-css-extract-plugin
export var active = "faqs-module--active--512b0";
export var answer = "faqs-module--answer--befe6";
export var faqFadeIn = "faqs-module--faqFadeIn--5fc61";
export var faqs_wrapper = "faqs-module--faqs_wrapper--b12de";
export var question = "faqs-module--question--e1767";
export var question_wrapper = "faqs-module--question_wrapper--b6625";
export var svg_active = "faqs-module--svg_active--39a36";